/* eslint-disable @angular-eslint/no-output-native */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'lcs-spin-button',
    templateUrl: './spin-button.component.html',
    styleUrls: ['spin-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'lcs-spin-button',
    },
    standalone: false
})
export class LcsSpinButtonComponent {
   @Input() name: string;

   @Input() decrementText: string;

   @Input() incrementText: string;

   @Input() value: string | number | null;

   @Input() valueText: string | null;

   @Input() valueMin: string | number | null;

   @Input() valueMax: string | number | null;

   @Output() decrement = new EventEmitter<never>();

   @Output() increment = new EventEmitter<never>();

   @Output() pageDown = new EventEmitter<never>();

   @Output() pageUp = new EventEmitter<never>();

   @Output() home = new EventEmitter<never>();

   @Output() end = new EventEmitter<never>();

   @Output() keydownEvent = new EventEmitter<KeyboardEvent>();

   onIncrementClick(): void {
      this.increment.emit();
   }

   onDecrementClick(): void {
      this.decrement.emit();
   }

   onKeydown(event: KeyboardEvent): void {
      event.preventDefault();
      event.stopPropagation();

      switch (event.key) {
         case 'ArrowDown':
            this.decrement.emit();
            break;
         case 'ArrowUp':
            this.increment.emit();
            break;
         case 'PageDown':
            this.pageDown.emit();
            break;
         case 'PageUp':
            this.pageUp.emit();
            break;
         case 'Home':
            this.home.emit();
            break;
         case 'End':
            this.end.emit();
            break;
         default:
            this.keydownEvent.emit(event);
            break;
      }
   }
}
